"use client"

import React, { useRef, useEffect, useState } from "react";
import MediaBoxes from "../../components/MediaBoxes/MediaBoxes";
import PropTypes from 'prop-types';

function MediaPage({ blok }) {

  return (
    <div className="pb-20">
      <div
        className="bg-asmPageTopBG"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "bottom", // Center the background image
          backgroundRepeat: "repeat", // Prevent repeating the background
          // maxWidth: 1920,
          // margin: "auto",
        }}
      >
        <div className="max-w-[1920px] m-auto">
          <div className="relative lg:min-h-[1000px] lg:flex flex-col items-center py-8 max-w-[1920px] m-auto">
            {/* Header Section */}
            <div className="font-aileron py-20 lg:py-32 text-center font-bold">
              <h1 className="bg-custom-radial bg-clip-text text-transparent text-[48px] lg:text-[80px]">
                {blok.Title}
              </h1>
              {/* <div className="font-lato mt-4 text-[20px] w-[80%] lg:w-[90%] m-auto lg:text-[32px] font-normal ">
                {blok.Subtitle}
              </div> */}
            </div>

            <div className="lg:w-[1500px] lg:p-0 p-4 space-y-[40px] -mt-20">
              {blok.Media.map((media, index) => (
                <MediaBoxes
                  key={index}
                  title={media.title}
                  subtitle={media.subtitle}
                  // description={media.description}
                  buttonText={media.buttonText}
                  url={media.url.url}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer blok={blok} /> */}
    </div>
  );
}
MediaPage.propTypes = {
  blok: PropTypes.shape({
    titleText1: PropTypes.string,
    titleText2: PropTypes.string
  }).isRequired
};

export default MediaPage;

